<div *ngIf="abrirModal" class="general-modal">
  <div class="general-modal-contenido">
    <span class="general-cerrar-modal" (click)="cerrarDialogoFinalizacion()">&times;</span>
    <div>
      <div>
        <span class="material-symbols-outlined material-symbols-filled header-icon" [ngClass]="tipo">{{icono}}</span>
        <p class="header-icon-title" [ngClass]="tipo" *ngIf="titulo">{{titulo}}</p>
        <p class="body-modal">{{mensaje}}</p>
      </div>
      <button class="btn submit-btn" (click)="cerrarDialogoFinalizacion()">
        CERRAR
      </button>
    </div>
  </div>
</div>